import { Fragment } from "react";
import FooterPostup from "../../../modules/public/footer/footer";
import Menu from "../../../modules/public/menu/menu";

import { Link, Outlet, useLocation } from "react-router-dom";
import style from "./register.module.css";

export default function Register() {
  const location = useLocation();
  return (
    <Fragment>
      <Menu />
      <main
        className={
          "d-flex justify-content-center align-items-center " + style.main
        }
      >
        {location.pathname === "/register" && (
          <section
            className={"d-flex justify-content-evenly flex-wrap " + style.box}
          >
            <Link to={"agent"}>
              <article className={style.icon}>
                <img src="/postupPics/firstSegment/agent.png" />
                <p className="optionTitle">اخذ نمایندگی</p>
              </article>
            </Link>

            <Link to={"user"}>
              <article className={style.icon}>
                <img src="/postupPics/firstSegment/about.png" />
                <p className="optionTitle">ثبت نام کاربر</p>
              </article>
            </Link>
          </section>
        )}

        <Outlet />
      </main>
      <FooterPostup />
    </Fragment>
  );
}
